export const PageHeader = ({ title, description, action, testId }) => {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between mb-6" data-testid={testId || "page-header"}>
      <div>
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-[#111827]">{title}</h1>
        {description && <p className="mt-1 text-sm text-[#6B7280]">{description}</p>}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
};
